import classnames from "classnames";
import { Form, Formik } from "formik";

import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { companies } from "../../common/data";
import SignContext from "../../contextAPI/Context/SignContext";

function Example({ companyId, location, allcompany }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const {
    GetCompanybyId,
    GetEmpsbyCompAndLoc,
    GetContactDetailsById,
    AddEmployee,
    AddContact,
  } = useContext(SignContext);

  const [Location, setLocation] = useState([]);
  const [Category, setCategory] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [EmpbyCompandLoc, setEmpbyCompandLoc] = useState([]);
  const [currentEmp, setCurrentEmp] = useState(null);
  const [currentEmpContactDetails, setCurrentEmpContactDetails] =
    useState(null);
  const [a1, seta1] = useState([]);
  const [a2, seta2] = useState([]);
  const [empId, setEmpId] = useState(null);

  // Debug the structure of allcompany array
  if (allcompany && allcompany.length > 0) {
    // Find and log the specific company we're looking for
    const targetCompany = allcompany.find(({ _id }) => _id === companyId);
    if (targetCompany) {
      // Company found
    } else {
      // Company not found
    }
  }

  // const res1 = allcompany.find(({ _id }) => _id === companyId);
  // seta1(res1.companyJobCategorys)
  // setDepartment(res1.companyDepartments);

  const getEmpContactDetails = async (id) => {
    try {
      const res = await GetContactDetailsById(id);

      // GetContactDetailsById now returns response.data which contains { data: contactDetails }
      setCurrentEmpContactDetails(res.data);
    } catch (error) {
      setCurrentEmpContactDetails(null);
    }
  };

  const getcompaniesbyId = async (id) => {
    try {
      const res = await GetCompanybyId(id);

      // With axios interceptor, response structure is: { success, message, data, timestamp }
      // Access the nested data object
      const companyData = res.data || res;

      setLocation(companyData.companyLocation || []);
      setCategory(companyData.companyJobCategorys || []); // Keep for compatibility
      setDepartment(companyData.companyDepartments || []); // Keep for compatibility

      // Update the state variables actually used by the form
      seta1(companyData.companyDepartments || []); // Departments for form
      seta2(companyData.companyJobCategorys || []); // Categories for form

      // Verify state after setting
      setTimeout(() => {}, 100);
    } catch (error) {
      // Reset state on error
      setLocation([]);
      setCategory([]);
      setDepartment([]);
      seta1([]);
      seta2([]);
    }
  };

  const handleSavedCompandLoc = async (Values) => {
    const res = await GetEmpsbyCompAndLoc(Values);

    setEmpbyCompandLoc(res.data);
  };

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const handleSavedEmployee = async (Values) => {
    try {
      // Validate companyId and location are set
      if (!companyId) {
        throw new Error("Please select a company first");
      }
      if (!location) {
        throw new Error("Please select a location first");
      }

      const data = {
        ...Values,
        companyId,
        companyLocation: location,
      };

      const res = await AddEmployee(data);

      if (res && res._id) {
        setEmpId(res._id);
        return { success: true, id: res._id };
      } else {
        throw new Error(res?.message || "Failed to add employee");
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || "Failed to add employee",
      };
    }
  };

  //handle save contact detail...
  const handleSavedcat = async (Values) => {
    try {
      if (!empId) {
        throw new Error(
          "Employee ID is missing. Please add employee details first.",
        );
      }

      const data1 = { ...Values, companyId, employeeId: empId };
      const res = await AddContact(data1);

      // Check if response is successful (no error property)
      if (res && !res.error) {
        toast.success("Employee and contact details added successfully!");
        setTimeout(() => {
          navigate("/form");
        }, 1500);
        return { success: true };
      } else {
        throw new Error(res?.error || "Failed to add contact details");
      }
    } catch (error) {
      toast.error(error.message || "Failed to add contact details");
      return { success: false, error: error.message };
    }
  };

  // Validation schema for employee form
  const employeeValidationSchema = Yup.object().shape({
    employeeNameAbbrevation: Yup.string().required("Title is required"),
    employeeName: Yup.string().required("Name is required"),
    employeeFatherName: Yup.string().required("Father's name is required"),
    employeeSurname: Yup.string(),
    ecNo: Yup.string(),
    companyJobCategorys: Yup.string(), // Optional
    companyDepartments: Yup.string(), // Optional
  });

  // Validation schema for contact details form
  const contactValidationSchema = Yup.object().shape({
    address: Yup.string().required("Address is required"),
    email: Yup.string()
      .email("Invalid email format")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email format",
      ),
    age: Yup.number()
      .required("Age is required")
      .min(18, "Age must be at least 18")
      .max(100, "Age must not exceed 100")
      .integer("Age must be a whole number"),
    dateOfBirth: Yup.date().required("Date of birth is required"),
    gender: Yup.string()
      .required("Gender is required")
      .oneOf(
        ["Male", "Female", "Other"],
        "Gender must be Male, Female, or Other",
      ),
    height: Yup.number()
      .required("Height is required")
      .min(50, "Height must be at least 50 cm")
      .max(300, "Height must not exceed 300 cm"),
    bloodGroup: Yup.string().oneOf(
      ["", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
      "Invalid blood group. Must be A+, A-, B+, B-, AB+, AB-, O+, or O-",
    ),
    mentalStatus: Yup.string().required("Marital status is required"),
    mobileNumber: Yup.string().test(
      "is-valid-mobile",
      "Mobile number must be exactly 10 digits",
      function (value) {
        if (!value || value.trim() === "") return true;
        return /^[0-9]{10}$/.test(value);
      },
    ),
    office: Yup.string(),
    pp: Yup.string(),
    emer: Yup.string().test(
      "is-valid-emergency",
      "Emergency number must be exactly 10 digits",
      function (value) {
        if (!value || value.trim() === "") return true;
        return /^[0-9]{10}$/.test(value);
      },
    ),
    dateOfJoin: Yup.date(),
    idMark: Yup.string().required("ID mark is required"),
    natureOfJob: Yup.string().required("Nature of job is required"),
  });

  const handleLocationChange = (e) => {
    let selectedCompanyId = e.target.value;

    if (selectedCompanyId) {
      getcompaniesbyId(selectedCompanyId);
    }
  };

  const handleEmpData = (e) => {
    let data = e.target.value;

    const curremp = EmpbyCompandLoc.filter((emp) => emp._id === data);

    // Check if employee exists and has contact details ID
    if (curremp && curremp.length > 0 && curremp[0]) {
      if (curremp[0].employeeContactDetailsId) {
        getEmpContactDetails({ id: curremp[0].employeeContactDetailsId });
      } else {
        setCurrentEmpContactDetails(null);
      }
      setCurrentEmp(curremp[0]);
    } else {
      setCurrentEmp(null);
      setCurrentEmpContactDetails(null);
    }
  };

  // Removed redundant API calls - parent component (NewForm) already fetches company data
  // and passes it via allcompany prop

  useEffect(() => {}, [currentEmp]);

  useEffect(() => {
    // Primary data source: use allcompany prop if available and complete
    if (
      allcompany &&
      Array.isArray(allcompany) &&
      allcompany.length > 0 &&
      companyId
    ) {
      const res1 = allcompany.find(({ _id }) => _id === companyId);

      if (res1) {
        // Check if company has complete data (departments and categories)
        if (res1.companyDepartments && res1.companyJobCategorys) {
          seta1(res1.companyDepartments || []);
          seta2(res1.companyJobCategorys || []);

          return;
        } else {
          getcompaniesbyId(companyId);
          return;
        }
      } else {
        // Company not found in allcompany, fetch it directly
        getcompaniesbyId(companyId);
        return;
      }
    }

    // Fallback: fetch company data directly if not available in prop
    if (companyId && (!allcompany || allcompany.length === 0)) {
      getcompaniesbyId(companyId);
    } else if (!companyId) {
      seta1([]);
      seta2([]);
      setLocation([]);
      setCategory([]);
      setDepartment([]);
    } else {
      // No additional action needed
    }
  }, [allcompany, companyId]);

  // Debug useEffect - this should always run on mount and updates
  useEffect(() => {});

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="text-end mb-3 me-4">
        <Button className="btn btn-success w-sm" onClick={handleShow}>
          Add Employee here
        </Button>
      </div>

      <Modal size="lg" show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <Formik
                initialValues={{
                  employeeNameAbbrevation: "",
                  employeeName: "",
                  employeeFatherName: "",
                  employeeSurname: "",
                  ecNo: "",
                  companyJobCategorys: "",
                  companyDepartments: "",
                }}
                validationSchema={employeeValidationSchema}
                onSubmit={async (values, { resetForm }) => {
                  const result = await handleSavedEmployee(values);

                  if (result.success) {
                    resetForm();
                    toast.success(
                      "Employee added successfully! Now add contact details.",
                      {
                        autoClose: 3000,
                      },
                    );
                  } else {
                    toast.error(result.error || "Failed to add employee", {
                      autoClose: 5000,
                    });
                  }
                }}
              >
                {({
                  isSubmitting,
                  handleChange,
                  handleSubmit,
                  errors,
                  touched,
                  values,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Card>
                      <CardHeader>
                        <Row className="g-1 m-1">
                          <Col className="col-sm">
                            <div className="d-flex justify-content-sm-between">
                              <h2 className="card-title mb-0 justify-content-sm-start">
                                <strong>Add Employee</strong>
                              </h2>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <div className="card-body">
                        <div className="live-preview">
                          <Row className="align-items-center g-3">
                            <Col lg={2} md={2}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Title
                              </label>
                              <div className="">
                                <select
                                  className="form-select"
                                  name="employeeNameAbbrevation"
                                  onChange={(e) => {
                                    handleChange(e);
                                    handleEmpData(e);
                                  }}
                                  onBlur={handleBlur}
                                  value={values.employeeNameAbbrevation}
                                >
                                  <option value="">-select-</option>
                                  <option value="Mr.">Mr</option>
                                  <option value="Ms.">Ms</option>
                                  <option value="Mrs.">Mrs</option>
                                </select>
                                <p className="error text-danger">
                                  {errors.employeeNameAbbrevation &&
                                    touched.employeeNameAbbrevation &&
                                    errors.employeeNameAbbrevation}
                                </p>
                              </div>
                            </Col>
                            <Col lg={4} md={4}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Name
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="Name"
                                  name="employeeName"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.employeeName}
                                />
                                <p className="error text-danger">
                                  {errors.employeeName &&
                                    touched.employeeName &&
                                    errors.employeeName}
                                </p>
                              </div>
                            </Col>
                            <Col lg={3} md={3}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Father's Name
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="Father's Name"
                                  name="employeeFatherName"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.employeeFatherName}
                                />
                                <p className="error text-danger">
                                  {errors.employeeFatherName &&
                                    touched.employeeFatherName &&
                                    errors.employeeFatherName}
                                </p>
                              </div>
                            </Col>
                            <Col lg={3} md={3}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Surname
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="Surname"
                                  name="employeeSurname"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.employeeSurname}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="align-items-center g-3">
                            <Col lg={3} md={4}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                EC No.
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="EC No."
                                  name="ecNo"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.ecNo}
                                />
                              </div>
                            </Col>

                            <Col lg={4} md={4}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-inputrd"
                              >
                                Category
                              </label>
                              <div className="">
                                {(() => {
                                  return null;
                                })()}
                                <select
                                  className="form-select"
                                  name="companyJobCategorys"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  value={values.companyJobCategorys}
                                >
                                  <option value="">--select--</option>
                                  {a2 && a2.length > 0 ? (
                                    a2.map((name, index) => {
                                      return (
                                        <option key={index} value={name}>
                                          {name}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option value="" disabled>
                                      No categories available
                                    </option>
                                  )}
                                </select>
                                <p className="error text-danger">
                                  {errors.companyJobCategorys &&
                                    touched.companyJobCategorys &&
                                    errors.companyJobCategorys}
                                </p>
                              </div>
                            </Col>

                            {/* setting category by api */}

                            {/* <Col sm={3}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-input"
                              >
                                Department
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="company Departments"
                                  name="companyDepartments"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={
                                    currentEmp
                                      ? currentEmp.companyJobCategorys
                                      : ""
                                  }
                                />
                              </div>
                            </Col> */}

                            {/* //setting Department */}

                            <Col lg={4} md={4}>
                              <label
                                className="form-label mt-3"
                                htmlFor="product-orders-inputrd"
                              >
                                Department
                              </label>
                              <div className="">
                                {(() => {
                                  return null;
                                })()}
                                <select
                                  className="form-select"
                                  name="companyDepartments"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  value={values.companyDepartments}
                                >
                                  <option value="">--select--</option>
                                  {a1 && a1.length > 0 ? (
                                    a1.map((name, index) => {
                                      return (
                                        <option key={index} value={name}>
                                          {name}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option value="" disabled>
                                      No departments available
                                    </option>
                                  )}
                                </select>
                                <p className="error text-danger">
                                  {errors.companyDepartments &&
                                    touched.companyDepartments &&
                                    errors.companyDepartments}
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="text-end mb-3 me-3">
                        <button className="btn btn-success w-sm" type="submit">
                          Submit
                        </button>
                      </div>
                    </Card>
                  </Form>
                )}
              </Formik>

              <Formik
                initialValues={{
                  address: "",
                  age: "",
                  dateOfBirth: "",
                  gender: "",
                  height: "",
                  bloodGroup: "",
                  mentalStatus: "",
                  dateOfJoin: "",
                  idMark: "",
                  natureOfJob: "",

                  mobileNumber: "",
                  office: "",
                  pp: "",
                  emer: "",
                  email: "",
                }}
                validationSchema={contactValidationSchema}
                onSubmit={async (values, { resetForm }) => {
                  const result = await handleSavedcat(values);

                  if (result && result.success) {
                    resetForm();
                    handleClose();
                  }
                  // Toast is handled in handleSavedcat
                }}
              >
                {({
                  isSubmitting,
                  handleChange,
                  handleSubmit,
                  errors,
                  touched,
                  values,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form>
                    <Card>
                      <CardHeader>
                        <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              Contact Details
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </CardHeader>
                      <CardBody>
                        <TabContent activeTab={customActiveTab}>
                          <TabPane id="addproduct-general-info" tabId="1">
                            <Row>
                              <Col lg={8}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="manufacturer-name-input"
                                  >
                                    Address
                                  </label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="manufacturer-name-input"
                                    name="address"
                                    placeholder="address"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.address}
                                  />
                                  <p className="error text-danger">
                                    {errors.address &&
                                      touched.address &&
                                      errors.address}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={8} md={8}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="manufacturer-name-input"
                                  >
                                    Email
                                  </label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="manufacturer-name-input"
                                    name="email"
                                    placeholder="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                  />
                                  <p className="error text-danger">
                                    {errors.email &&
                                      touched.email &&
                                      errors.email}
                                  </p>
                                </div>
                              </Col>
                              <Col lg={2} md={4}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-stock-input"
                                  >
                                    Age
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="product-stock-input"
                                      placeholder="age"
                                      name="age"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.age}
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.age && touched.age && errors.age}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={3} md={4}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-price-input"
                                  >
                                    Date of Birth
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="date"
                                      className="form-control"
                                      id="product-price-input"
                                      placeholder="DD/MM/YYYY"
                                      name="dateOfBirth"
                                      aria-label="Price"
                                      aria-describedby="product-price-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.dateOfBirth}
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.dateOfBirth &&
                                      touched.dateOfBirth &&
                                      errors.dateOfBirth}
                                  </p>
                                </div>
                              </Col>

                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-Discount-input"
                                  >
                                    Gender
                                  </label>
                                  <div className="input-group mb-3">
                                    <select
                                      className="form-select"
                                      id="product-gender-input"
                                      name="gender"
                                      aria-label="Gender"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.gender}
                                    >
                                      <option value="" disabled>
                                        Select Gender
                                      </option>
                                      <option value="Male">Male</option>
                                      <option value="Female">Female</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>
                                  <p className="error text-danger">
                                    {errors.gender &&
                                      touched.gender &&
                                      errors.gender}
                                  </p>
                                </div>
                              </Col>

                              <Col lg={3} md={4}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Height
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder="height"
                                      name="height"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.height}
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.height &&
                                      touched.height &&
                                      errors.height}
                                  </p>
                                </div>
                              </Col>
                              <Col lg={3} md={4}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Blood Group
                                  </label>
                                  <div className="input-group mb-3">
                                    <select
                                      className="form-select"
                                      id="product-bloodgroup-input"
                                      name="bloodGroup"
                                      aria-label="Blood Group"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.bloodGroup}
                                    >
                                      <option value="">
                                        Select Blood Group
                                      </option>
                                      <option value="A+">A+</option>
                                      <option value="A-">A-</option>
                                      <option value="B+">B+</option>
                                      <option value="B-">B-</option>
                                      <option value="AB+">AB+</option>
                                      <option value="AB-">AB-</option>
                                      <option value="O+">O+</option>
                                      <option value="O-">O-</option>
                                    </select>
                                  </div>
                                  <p className="error text-danger">
                                    {errors.bloodGroup &&
                                      touched.bloodGroup &&
                                      errors.bloodGroup}
                                  </p>
                                </div>
                              </Col>
                              <Col lg={3} md={4}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-Discount-input"
                                  >
                                    Martial Status
                                  </label>
                                  <div className="input-group mb-3">
                                    <select
                                      className="form-select"
                                      id="product-gender-input"
                                      name="mentalStatus"
                                      aria-label="Gender"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.mentalStatus}
                                    >
                                      <option value="" disabled>
                                        --select--
                                      </option>
                                      <option value="Married">Married</option>
                                      <option value="Unmarried">
                                        Unmarried
                                      </option>
                                      <option value="Others">Others</option>
                                    </select>
                                  </div>
                                  <p className="error text-danger">
                                    {errors.mentalStatus &&
                                      touched.mentalStatus &&
                                      errors.mentalStatus}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              {/* <Col sm={2}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-stock-input"
                                  >
                                    Res
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-stock-input"
                                      placeholder="res"
                                      name="res"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.res} // res
                                    />
                                  </div>
                                </div>
                              </Col> */}

                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-price-input"
                                  >
                                    MOB
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-price-input"
                                      placeholder="10-digit mobile number"
                                      name="mobileNumber"
                                      aria-label="Price"
                                      aria-describedby="product-price-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.mobileNumber}
                                      maxLength="10"
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.mobileNumber &&
                                      touched.mobileNumber &&
                                      errors.mobileNumber}
                                  </p>
                                </div>
                              </Col>

                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Office
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder="Office"
                                      name="office"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.office}
                                    />
                                  </div>
                                </div>
                              </Col>

                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    PP #
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder="PP #"
                                      name="pp"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.pp}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Emergency Number
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder="10-digit emergency number"
                                      name="emer"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.emer}
                                      maxLength="10"
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.emer && touched.emer && errors.emer}
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-price-input"
                                  >
                                    Date of Joining
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="date"
                                      className="form-control"
                                      id="product-price-input"
                                      placeholder="DD/MM/YYYY"
                                      name="dateOfJoin"
                                      aria-label="Price"
                                      aria-describedby="product-price-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.dateOfJoin} //dateOfJoin
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.doj && touched.doj && errors.doj}
                                  </p>
                                </div>
                              </Col>
                              <Col lg={3} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-price-input"
                                  >
                                    ID Marks
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-price-input"
                                      placeholder="Marks on body"
                                      name="idMark"
                                      aria-label="Price"
                                      aria-describedby="product-price-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.idMark} // idMark
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.idMark &&
                                      touched.idMark &&
                                      errors.idMark}
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={6} md={8}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-price-input"
                                  >
                                    Nature of Job
                                  </label>
                                  <div className="input-group mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-price-input"
                                      placeholder="nature of job"
                                      name="natureOfJob"
                                      aria-label="Price"
                                      aria-describedby="product-price-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.natureOfJob}
                                    />
                                  </div>
                                  <p className="error text-danger">
                                    {errors.natureOfJob &&
                                      touched.natureOfJob &&
                                      errors.natureOfJob}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </TabPane>
                        </TabContent>
                      </CardBody>
                      <div className="text-end mb-3">
                        <button
                          type="submit"
                          className="btn btn-success w-sm"
                          // onClick={togglesuccessmodal}
                        >
                          Submit
                        </button>
                      </div>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default Example;
